<template>tariff</template>

<script lang="ts">
import {defineComponent} from "vue";
export default defineComponent({
  name: "TariffPage"
});
</script>
